import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { BotType, DcaType, SUB_TIER, TimeWindow } from "../../../../Const";
import { getTvTimeframe } from "../../../../utils/TvUtils";
import TVChartContainer from "../../TVChartContainer";
import { checkSub, isPro } from "../../../../utils/SubUtils";
import { CHANGE_BACKTEST_CUSTOM, CHANGE_TIME_FRAME, CHANGE_TRASACTION_FEE, SET_APPLY_CURRENT_DEAL } from "../../../../actions/create-bot-type";
import { resetBotConfig, runBackTest } from "../../../../actions/create-bot-action";
import { GET_BACKTEST_SUCCESS } from "../../../../actions/types";
import { restrictAlphabets } from "../../../../utils/Utils";
import useLoading from "../../../hooks/useLoading";
import { toast } from "react-toastify";
import Loading from "../../../common/Loading";
import BotPerformance from "../backtest/BotPerformance";
import CreateBotSection from "./CreateBotSection";
import CustomBackTest from "../backtest/CustomBackTest";
import CustomCheckbox from "./CustomCheckbox";

const BackTestSection = (props)=>{
    const {resetBotConfig,runBackTest} = props;
    const TimeFrame_1D = ["1D", "1W", "1M", "3M", "6M", "1Y","3Y"];
    const TimeFrame_1H = ["1D", "1W", "1M", "3M", "6M", "1Y","3Y"];
    const TimeFrame_15m = ["1D", "1W", "1M", "3M", "6M", "1Y","3Y"];
    const TimeFrame_5m = ["1D", "1W", "1M", "3M", "6M", "1Y","3Y"];
    const TimeFrame_1m = ["1D", "3D", "1W", "2W", "3W", "1M","3M"];
    const Frequencies = {
        15: "15",
        60: "60",
        120: "120",
        240: "240",
        1440: "1D",
      };
      const FrequenciesPro = {
        1:"1",
        5: "5",
        15: "15",
        60: "60",
        120: "120",
        240: "240",
        1440: "1D",
      };
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const newBot = useSelector((state) => state.createBot.newBot);
    const [isCustomInterval, setIsCustomInterval] = useState(false);
    const [setLoading, bindLoading] = useLoading(false);
    const baseCoin = newBot.baseCoin;
    const quoteCoin = newBot.quoteCoin;
    const frequency = newBot.frequency;
    const strategy = newBot.strategy;
    const isPercentDca = newBot.dcaType === DcaType.sellUp || newBot.dcaType === DcaType.buyDown
    const pair = newBot.pair;
    const reloadTV = useSelector((state) => state.bots.reloadTV);
    const [timeFrames, setTimeFrames] = useState(TimeFrame_1D);
    const [interval, setInterval] = useState(timeFrames[timeFrames.length - 2]);
    const subscription = useSelector(
        (state) => state.auth.user.user_subscription
      );
    const { subPremium, subTier } = checkSub(subscription);
    const isProffessional = isPro(subscription);
    const frequencyVal= (subPremium && isProffessional)?FrequenciesPro:Frequencies;
    const formatDecimal = (value,decimals) =>{
      if(value=="")
      return
      return Number(Number(value).toFixed(decimals));
    } 
    const timeFrameButtons = timeFrames.map((item, index) => {
      const buttonClass = ` ${
        (item == interval &&  !isCustomInterval)? "pacp-active" : ""
      }`;
      if (item === "3Y" && !isProffessional) {
        return (
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={<Tooltip id={`tooltip-${index}`}>{t("Only for Professional subscribers")}</Tooltip>}
          >
            <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
              <button 
                className={buttonClass}
                style={{ opacity: 0.5, pointerEvents: 'none' }}
                onClick={(e) => e.preventDefault()}
              >
                {item}
              </button>
            </span>
          </OverlayTrigger>
        );
      }
      return (
        <button key={index} className={buttonClass} onClick={() => clickInterval(item)}>{item}</button>
      );
    });
    useEffect(() => {
        let newInterval;
        switch (frequency) {
          case 1:
            setTimeFrames(TimeFrame_1m);
            newInterval = TimeFrame_1m[TimeFrame_1m.length - 1];
            break;
          case 5:
            setTimeFrames(TimeFrame_5m);
            newInterval = TimeFrame_5m[TimeFrame_5m.length - 2];
            break;
          case 15:
            setTimeFrames(TimeFrame_15m);
            newInterval = TimeFrame_15m[TimeFrame_15m.length - 2 ];
            break;
          case 60:
            setTimeFrames(TimeFrame_1H);
            newInterval = TimeFrame_1H[TimeFrame_1H.length - 2];
            break;
          default:
            setTimeFrames(TimeFrame_1D);
            newInterval = TimeFrame_1D[TimeFrame_1D.length - 1];
        }
        if (newInterval === "3Y" && !isProffessional) {
            newInterval = "1Y";
        }
        setInterval(newInterval);
      }, [frequency, isProffessional]);
      const clickInterval = (val) => {
        setIsCustomInterval(false)
        setInterval(val);
      };
      const changeTimeFrame = (val) => {
        dispatch({
          type: CHANGE_TIME_FRAME,
          payload: val,
        });
      };
      useEffect(() => {
        changeTimeFrame(TimeWindow[interval]);
      }, [interval]);
      const changeBacktestTimeframe = (val) => {
        setIsCustomInterval(true)
        if(frequency <=15 && val > 180){
          changeTimeFrame(180);
          return false;
        }
        changeTimeFrame(val);
      };
      useEffect(() => {
        window.bot = { strategy, orders: [] };
        return () => {
          resetBotConfig();
          dispatch({
            type: GET_BACKTEST_SUCCESS,
            payload: null,
          });
        };
      }, []);
    
      const setCustomBacktest = (val) => {
        dispatch({
          type: CHANGE_BACKTEST_CUSTOM,
          payload: val,
        });
      };
      const changeTransactionFee = (val) => {
        dispatch({
          type: CHANGE_TRASACTION_FEE,
          payload: val,
        });
       
        
      };
      const clickBackTest = () => {
        setLoading(true);
        runBackTest()
          .then(() => {
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            toast.error(t(err));
          });
      };
    return(<>
            <div className="ba-asset-middle-chart-item" style={{ height: "525px" }}>
               
                    {pair && <TVChartContainer
                      pairId={pair.id}
                      symbol={`${baseCoin}/${quoteCoin}`}
                      interval={((newBot.botType == BotType.dca) && (isPercentDca) )? FrequenciesPro[frequency]:frequencyVal[frequency]}
                      reload={reloadTV}
                      timeframe={getTvTimeframe(interval)}
                      pricePrecision={newBot.pricePrecision}
                      />}
                </div>     
                <div className="ba-asset-chart-pag">
                  {timeFrameButtons}
                </div>
                <div className="ba-asset-backtest-area">
                  <div className="row">
                  <div className="col-lg-6">
                  
                          <div className="ba-asset-backtest-left">
                          {(subPremium && isProffessional && (newBot.botType !=BotType.grid && newBot.botType !=BotType.sell)) &&
                            <label>
                            {t("backtest-from")}    
                            <input
                                  type="number"
                                  value={newBot.timeFrame}
                                  onChange={(e) => {
                                    changeBacktestTimeframe(e.target.value);
                                  }}
                                  onKeyPress={(e) => {
                                    restrictAlphabets(e);
                                  }}
                                  className=""
                                />
                              {t("backtest-days-ago")}
                            </label>}
                            <label>
                            {t("transaction-fee")}
                            <Form.Control
                                        as="input"
                                        type="number"
                                        value={formatDecimal(newBot.transactionFee?newBot.transactionFee:"",2)}
                                        onChange={(e) => {
                                          changeTransactionFee(e.target.value);
                                        }}
                                        onKeyPress={(e) => {
                                          restrictAlphabets(e);
                                        }}
                                        className=""
                                      ></Form.Control>
                              %
                            </label>
                          </div>
                    </div>
                    {isPro(subscription) ?
                    <div className="col-lg-6">
												<div className="ba-asset-backtest-right">
                            <CustomCheckbox 
                                val={newBot.backtestCustom} 
                                checked={newBot.backtestCustom==1} 
                                callback={setCustomBacktest}
                                label={"Use Custom Date"}
                                id={'sccc'}
                                >
                            </CustomCheckbox>
												</div>
                        {newBot.backtestCustom &&
                            <CustomBackTest newBot={newBot}></CustomBackTest>
                            }
										</div>
                    :<></>}

                    <div className="col-lg-12">
												<div className="backtest-btn">
                        {(newBot.botType !=BotType.grid && newBot.botType !=BotType.sell) && 
													<button onClick={clickBackTest}>{t("run-backtest")}</button>
                        }
												</div>
											</div>
                    </div>
                    
                 
                </div>
                    
                
        <Loading {...bindLoading} />
        </>)
}

export default connect(null,{resetBotConfig,runBackTest}) (BackTestSection);